export default function () {
  return {
    rooms: [],
    activeRoomId: null,

    // mensagens por sala
    messagesByRoom: {},

    // loading por chave
    loading: {
      rooms: false,
      messages: false,
      searchUsers: false,
      createRoom: false
    },

    // UI
    ui: {
      isOpen: false
    },

    // busca usuários (Nova Conversa)
    searchResults: [],
    connected: false,
    onlineUsers: [],
    typingByRoom: {}
  }
}



// WEBPACK FOOTER //
// ./src/plugins/chat-plugin/store/state.js